import { useFetch, fmtDate } from "@/lib/shieldx";
import { PageHeader, Loader } from "@/components/shieldx/Primitives";
import { Table } from "@/components/shieldx/Table";
import { SecBadge } from "@/components/shieldx/SuperAdmin";
import { ScanSearch } from "lucide-react";

export default function SASecurityScreening() {
  const { data, loading } = useFetch("/super-admin/security-screening");
  if (loading || !data) return <Loader label="Screening all organizations and assets" />;
  const columns = [
    { key: "name", label: "Organization", render: (r) => <div><p className="font-medium text-slate-100">{r.name}</p><p className="font-mono text-[11px] text-slate-500">{r.type}</p></div> },
    { key: "category", label: "Category", render: (r) => <span className="text-xs text-slate-400 capitalize">{r.category}</span> },
    { key: "security_status", label: "Evidence-Based Status", render: (r) => <SecBadge value={r.security_status} /> },
    { key: "rating", label: "Rating", render: (r) => <span className="font-mono tabular-nums text-slate-200">{r.rating}</span> },
    { key: "asset_count", label: "Assets", render: (r) => <span className="font-mono text-slate-300">{r.asset_count}</span> },
    { key: "active_incidents", label: "Active Incidents", render: (r) => <span className={r.active_incidents ? "font-mono text-amber-300" : "font-mono text-slate-500"}>{r.active_incidents}</span> },
    { key: "integrations_failed", label: "Failed Integrations", render: (r) => <span className={r.integrations_failed ? "font-mono text-red-400" : "font-mono text-slate-500"}>{r.integrations_failed}</span> },
  ];
  return (
    <div>
      <PageHeader icon={ScanSearch} title="Global Security Screening"
        subtitle="Evidence-based security posture. Status is never 'secure' merely because no incident exists — it reflects verification, protection dependencies, incidents and integration health." />
      <div className="mb-4 flex flex-wrap gap-2 text-[11px] text-slate-500">
        {["PROTECTED", "PROTECTION_DEGRADED", "AT_RISK", "VERIFICATION_REQUIRED", "CONFIGURATION_REQUIRED", "UNKNOWN", "SUSPENDED", "REVOKED"].map((s) => <SecBadge key={s} value={s} />)}
      </div>
      <Table columns={columns} rows={data} testid="sa-screening-table" empty="No organizations" />
    </div>
  );
}
